import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { colorPrimaryNavy } from 'customColors';

const STEPS = [
  {
    number: 1,
    title: 'Find an event',
    description: 'Browse upcoming events your campus is hosting in Explore.',
  },
  {
    number: 2,
    title: 'Show your QR',
    description: 'Open your personal event QR when you arrive. An organization leader scans it.',
  },
  {
    number: 3,
    title: 'Watch your record grow',
    description: 'Hours, competencies, and approver signatures appear here automatically.',
  },
];

export const CoCurricularEmptyState = (): ReactElement => {
  const router = useRouter();

  return (
    <Box sx={{ marginBottom: '48px' }}>
      <Typography
        sx={{
          fontSize: '28px',
          fontWeight: 700,
          color: '#1F1F1F',
          marginBottom: '12px',
        }}
      >
        Your record begins at your first check-in
      </Typography>
      <Typography
        sx={{
          fontSize: '14px',
          color: '#6B6B6B',
          marginBottom: '24px',
          maxWidth: '900px',
        }}
      >
        When an organization leader scans your personal event QR at an event, that attendance
        becomes part of your verified Co-curricular Record. Hours credit automatically,
        competencies build over time, and at the end of each term you can export an
        institutional PDF.
      </Typography>

      <Box
        display="flex"
        gap="16px"
        sx={{ flexDirection: { xs: 'column', md: 'row' }, marginBottom: '24px' }}
      >
        {STEPS.map((step) => (
          <Box
            key={step.number}
            sx={{
              flex: 1,
              backgroundColor: '#F0F0F0',
              borderRadius: '8px',
              padding: '16px',
            }}
          >
            <Box
              sx={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                backgroundColor: colorPrimaryNavy,
                color: '#fff',
                fontSize: '12px',
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '12px',
              }}
            >
              {step.number}
            </Box>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 600,
                color: '#1F1F1F',
                marginBottom: '4px',
              }}
            >
              {step.title}
            </Typography>
            <Typography sx={{ fontSize: '14px', color: '#6B6B6B' }}>
              {step.description}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box
        component="button"
        onClick={() => router.push('/explore')}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          backgroundColor: colorPrimaryNavy,
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          padding: '10px 20px',
          fontSize: '14px',
          fontWeight: 600,
          fontFamily: 'inherit',
          cursor: 'pointer',
        }}
      >
        Find events
      </Box>
    </Box>
  );
};
